<template>
  <nav :class="'navbar navbar-expand-lg navbar-light bg-light fixed-top '+backgroundColorDevice">
    <div class="container-fluid">
      <img :src="logo" width="60px">
      <v-btn text :class="colorDevice" onclick="window.location.href='https://www.impresabaldassarriepace.it/'">
        {{title}}
      </v-btn>
      <div v-if="!$isMobile()" style="width: 100%;">
      </div>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item mr-4" v-for="tag in tags" :key="tag.text">
            <a :class="'nav-link d-flex justify-content-end '+colorDevice" :href="tag.href">
              <span class="material-icons pr-3">{{tag.icon}}</span>
              <span>{{tag.text}}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    name: 'Navbar',
    data: () => ({
      backgroundColorDevice: "desktop-background-color",
      colorDevice: "desktop-color",
      logo: require("../assets/logoBackgroundColorPrimary.png"),
      title: 'Impresa Edile Baldassarri C. & Pace G. S.r.l.',
      tags:{
        services: {
          text: 'Servizi',
          href: 'https://www.impresabaldassarriepace.it/#servizi',
          icon: 'handyman'
        },
        works: {
          text: 'Lavori',
          href: 'https://www.impresabaldassarriepace.it/#lavori',
          icon: 'engineering'
        },
        quality: {
          text: 'Qualità',
          href: 'https://www.impresabaldassarriepace.it/#qualita',
          icon: 'local_fire_department'
        }, 
        history: {
          text: 'Storia',
          href: 'https://www.impresabaldassarriepace.it/#storia',
          icon: 'history'
        },
        contacts: {
          text: 'Contatti',
          href: 'https://www.impresabaldassarriepace.it/#contatti',
          icon: 'contacts'
        }
      },
      smartphoneTags:{
        services: {
          text: 'Servizi',
          href: 'https://www.impresabaldassarriepace.it/#servizi',
          icon: 'handyman'
        },
        works: {
          text: 'Lavori',
          href: 'https://www.impresabaldassarriepace.it/#lavori',
          icon: 'engineering'
        },
        quality: {
          text: 'Qualità',
          href: 'https://www.impresabaldassarriepace.it/#qualita',
          icon: 'local_fire_department'
        },
        contacts: {
          text: 'Contatti',
          href: 'https://www.impresabaldassarriepace.it/#contatti',
          icon: 'contacts'
        }
      }
    }),
    beforeCreate: function(){
      console.log("beforeCreate");
      console.log("detectMobileDevice: "+this.$isMobile());
    },
    created: function(){
      console.log("created");
      if(this.$isMobile()){
        this.title = "Impresa Edile B&P";
        this.tags = this.smartphoneTags;
        this.backgroundColorDevice = "smartphone-background-color";
        this.colorDevice = "smartphone-color";
        this.logo = require("../assets/logoBackgroundColorYellow.png");
      } 
    },
    beforeMount: function(){
      console.log("beforeMount");
    },
    mounted: function(){
      console.log("mounted");
    },
    beforeUpdate: function(){
      console.log("beforeUpdate");
    },
    updated: function(){
      console.log("updated");
    },
    beforeDestroy: function(){
      console.log("beforeDestroy");
    },
    destroy: function(){
      console.log("destroy");
    },
    methods: {
      functionExample(){
      }
    }
  }
</script>

